export default __webpack_public_path__ + "static/media/nft12.2b0c4961.png";